 <template>
  <div :class="['fivePage']">
    <div
      :class="['fiveIconPng', fiveTitShow ? 'imgAnimated imgFadeIn' : 'bgGray']"
    ></div>
    <div class="titHeader fiveAnimated" v-if="fiveTitShow">
      创新驱动发展，<br />全力推进林业信息化建设
      <span class="circle circleOne"></span>
      <span class="circle"></span>
    </div>
    <div class="titBox">
      <!-- <h4 class="tit fiveAnimated rotateInUpLeft" v-if="fiveTitShow">
        创新驱动发展，全力推进林业信息化建设
      </h4> -->
      <p class="textMian animated delay fadeIn" v-if="fiveTitShow">
        2019年07月，我院成立智能生态研究院，全面推进林业信息化研发，运用“互联网+林业”思维，积极开展林长制信息化综合管理平台、智慧林业、AI林业等相关林业信息化建设。
      </p>
      <!-- <p class="textMian animated fadeIn" v-if="pageFiveAction">
        2019年7月，成立东华智能生态研究院，全面推进林业科技研发，加快AI林业大脑、“互联网+林业”综合信息化管理平台建设、自然资源软件研发、自然资源大数据分析应用等相关工作。
      </p> -->
    </div>
    <div class="bwBox" v-if="fiveBtnShow" @click="changeHue">
      <div class="wave wave4"></div>
      <div class="wave wave3"></div>
      <div class="wave wave1"></div>
      <div class="wave waveOne">
        <!-- <img :src="baseUrl + 'img/dhShare/dianFive.png'" class="textAmation" /> -->
        <img :src="baseUrl + 'img/dhShare/dianIcon.png'" class="textAmation" />
      </div>
    </div>
    <div :class="['imgMainBox', fiveTitShow ? 'imgMainBoxShow' : '']">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperChild">
        <swiper-slide
          class="slideItem"
          v-for="(item, index) in slideList"
          :key="index"
        >
          <van-image
            fit="cover"
            @click="seeImg(item, index)"
            :src="baseUrl + item.imgUrl"
          />
        </swiper-slide>
      </swiper>
    </div>

    <van-overlay @click="bigImgShow = false" class="tkMain" :show="bigImgShow">
      <div class="wrapper">
        <van-image
          fit="cover"
          :src="baseUrl + bigImgUrl + '?x-oss-process=image/resize,p_50'"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import "@/assets/style/animate.min.less";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "@/assets/style/animate.min.less";
export default {
  name: "fivePage",
  props: {
    landscapeType: {
      type: Boolean,
      default: false,
    },
    newIndex: {
      type: String,
    },
  },
   components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      typePage: false,
      fiveTitShow: false,
      pageFiveAction: false,
      fiveBtnShow: true,
       bigImgShow: false,
      swiperOption: {
        loop: false,
        slidesPerView: 3, //数量
        spaceBetween: 15, //间距
        initialSlide: 1,
        centeredSlides: true,
        direction: "horizontal", //设置水平horizontal还是垂直vertical
      },
      bigImgUrl: "",
      slideList: [
        {
          imgUrl: "img/dhShare/fiveK001.jpg",
        },
        {
          imgUrl: "img/dhShare/fiveK002.jpg",
        },
        {
          imgUrl: "img/dhShare/fiveK003.jpg",
        },
        {
          imgUrl: "img/dhShare/fiveK004.jpg",
        },
        {
          imgUrl: "img/dhShare/fiveK005.jpg",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.typePage = this.landscapeType;
      this.initPage();
    });
  },
  methods: {
    initPage() {
      this.pageFiveAction = true;
    },

    changeHue() {
      this.fiveBtnShow = false;
      this.fiveTitShow = true;
    },
      seeImg(item) {
      this.bigImgShow = true;
      this.bigImgUrl = item.imgUrl;
    },
  },
  watch: {
    landscapeType: function (newVal) {
      this.typePage = newVal;
      if (newVal && this.newIndex == "4") {
        this.pageFiveAction = true;
      } else {
        this.pageFiveAction = false;
      }
    },
    newIndex: function (newValue) {
      if (newValue == "4") {
        this.pageFiveAction = true;
      } else {
        this.pageFiveAction = false;
      }
    },
  },
};
</script>
<style lang="less">
.fivePage {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/dhShare/slideFive.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  position: relative;
  .fiveIconPng {
    width: 100%;
    height: 100%;
    background-image: url("../../../../../public/img/dhShare/fiveIcon.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: relative;
    -webkit-filter: grayscale(90%); /* Chrome, Safari, Opera */
    filter: grayscale(90%);
  }
  .titHeader {
    top: 62%;
    right: -30px;
    border: 1px solid #fd6013;
    color: #fd6013;
    .circle {
      border: 1px solid #fd6013;
    }
  }
  .titBox {
    position: absolute;
    top: 145px;
    right: -55px;
    // .tit {
    //   width: 300px;
    //   position: absolute;
    //   top: 75px;
    //   left:-110px;
    //   font-size: 16px;
    //   color: #c6f6ef;
    //   font-weight: 600;
    // }
    .textMian {
      position: absolute;
      top: 80px;
      left: -110px;
      width: 235px;
      font-size: 12px;
      color: #fd6013;
      opacity: 0;
    }
  }
  
  .fiveAnimated {
    animation: bounceInDown 2s forwards linear;
    /* Safari 和 Chrome */
  }
  
  .imgMainBox {
    position: absolute;
    bottom: 25px;
    left: 0;
    
    z-index: 999;
    width: 100%;
    display: none;
    .swiperChild.swiper-container {
      width: 320px;
      height: 120px;
      .swiper-wrapper {
        margin-top: 15px;
        .slideItem.swiper-slide {
          width: 110px;
          height: 95px;
          background-color: #fff;
          z-index: 1000;
          border-radius: 10px;
          -webkit-border-radius: 10px;
          padding: 5px 5px;
          opacity: 0.7;
          .van-image {
            width: 100%;
            height: 100%;
            border-radius: 8px;
            img {
              border-radius: 8px;
            }
          }
        }
        .slideItem.swiper-slide.swiper-slide-active {
          transform: scale(1.2);
          opacity: 1;
        }
      }
    }
  }
  .tkMain.van-overlay {
    position: absolute !important;
    width: 100% !important;
    height: 75% !important;
    left: 0;
    top: 0;
    z-index: 9999;
    background-color: rgba(225, 225, 225, 0);
    overflow: hidden;

    .wrapper {
      position: absolute;
      width: 320px;
      height: 450px;
      background-color: #fff;
      padding: 5px 5px;
      left: 50%;
      top: 50%;
      margin-left: -155px;
      margin-top: -210px;
      border-radius: 10px;
      -webkit-border-radius: 10px;
    }

    .van-image {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      img {
        border-radius: 8px;
      }
    }
  }
  .imgMainBox.imgMainBoxShow {
    display: block;
  }
}
</style>